export const BellIcon: React.FC<React.SVGAttributes<{}>> = (props) => {
  return (
    <svg
      fill="currentColor"
      style={{
        verticalAlign: 'middle',
      }}
      height="1em"
      width="1em"
      viewBox="0 0 512 512"
      display="inline-block"
      {...props}
    >
      <path d="M381.7 225.9c0-97.6-52.5-130.8-101.6-138.2 0-.5.1-1 .1-1.6 0-12.3-10.9-22.1-24.2-22.1-13.3 0-23.8 9.8-23.8 22.1 0 .6 0 1.1.1 1.6-49.2 7.5-102 40.8-102 138.4 0 113.8-28.3 126-66.3 158h384c-37.8-32.1-66.3-44.4-66.3-158.2zM256.2 448c26.8 0 48.8-19.9 51.7-43H204.5c2.8 23.1 24.9 43 51.7 43z" />
    </svg>
  );
};
